import { useState, useRef, useEffect } from 'react';

const galleryImages = [
  {
    src: 'https://readdy.ai/api/search-image?query=organic%20black%20seed%20kalonji%20seeds%20closeup%20on%20white%20wooden%20surface%20natural%20premium%20food%20photography%20beautiful%20earthy%20tones%20seeds%20scattered%20artfully%20macro%20detail%20pure&width=600&height=700&seq=pf5001&orientation=portrait',
    alt: 'Organic black seeds',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=hand%20grinding%20spices%20mortar%20pestle%20traditional%20process%20organic%20masala%20natural%20herbs%20close%20up%20warm%20light%20artisan%20craft%20process%20photography%20beautiful%20detail%20stone&width=600&height=500&seq=pf5002&orientation=landscape',
    alt: 'Hand grinding spices',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=pure%20golden%20organic%20oils%20in%20glass%20bottles%20natural%20ingredients%20herbs%20leaves%20wooden%20surface%20warm%20earthy%20background%20premium%20product%20photography%20beautiful%20arrangement%20flat%20lay&width=600&height=600&seq=pf5003&orientation=squarish',
    alt: 'Organic oil bottles',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=organic%20whole%20spices%20star%20anise%20cinnamon%20cardamom%20cloves%20on%20dark%20rustic%20wooden%20surface%20beautiful%20arrangement%20natural%20ingredients%20photography%20warm%20golden%20lighting%20artisan%20premium&width=600&height=700&seq=pf5004&orientation=portrait',
    alt: 'Whole organic spices',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=coconut%20halved%20organic%20ingredients%20on%20natural%20wooden%20background%20with%20coconut%20flour%20scattered%20beautiful%20natural%20food%20photography%20warm%20cream%20tones%20premium%20minimal&width=600&height=500&seq=pf5005&orientation=landscape',
    alt: 'Coconut and flour',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=colorful%20organic%20spice%20powders%20turmeric%20coriander%20cumin%20in%20small%20wooden%20bowls%20arranged%20on%20rustic%20surface%20beautiful%20vibrant%20natural%20food%20photography%20premium%20artisan&width=600&height=600&seq=pf5006&orientation=squarish',
    alt: 'Colourful spice powders',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=organic%20seeds%20variety%20in%20glass%20jars%20wooden%20spoons%20beautiful%20arrangement%20natural%20background%20warm%20earthy%20tones%20premium%20food%20photography%20minimal%20clean%20serene&width=600&height=700&seq=pf5007&orientation=portrait',
    alt: 'Organic seeds in jars',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=traditional%20clay%20pottery%20bowls%20with%20organic%20herbs%20dried%20flowers%20spices%20natural%20arrangement%20rustic%20wooden%20surface%20warm%20earthy%20tones%20natural%20light%20premium%20food%20photography%20artisan&width=600&height=500&seq=pf5008&orientation=landscape',
    alt: 'Herbs in clay bowls',
    span: '',
  },
];

const GallerySection = () => {
  const [lightbox, setLightbox] = useState<string | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.scroll-animate').forEach((child) => {
              child.classList.add('visible');
            });
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setLightbox(null);
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, []);

  return (
    <section className="py-20 md:py-28 bg-brand-cream px-4 md:px-8" ref={ref}>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 scroll-animate">
          <span className="inline-block font-sans text-xs tracking-[0.25em] uppercase text-brand-olive font-medium mb-3">
            Gallery
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-brand-brown-dark font-bold mb-4">
            From Nature to Your Table
          </h2>
          <div className="w-16 h-0.5 bg-brand-gold mx-auto"></div>
        </div>

        {/* Masonry Grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4 scroll-animate">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="break-inside-avoid rounded-xl overflow-hidden cursor-pointer group relative"
              onClick={() => setLightbox(img.src)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-brand-brown-dark/0 group-hover:bg-brand-brown-dark/40 transition-all duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-2xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <div className="relative max-w-4xl max-h-[90vh] w-full">
            <img
              src={lightbox}
              alt="Gallery preview"
              className="w-full h-full object-contain rounded-xl"
            />
            <button
              className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-white/20 hover:bg-white/40 rounded-full text-white transition-colors cursor-pointer"
              onClick={() => setLightbox(null)}
            >
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
